// Error function
const extendError = (message) => {
  const error = new Error(message);
  error.name = 'extendError';
  return error;
};

// Pure function returning configuration
const getConfiguration = () => ({
  currency: 'USD',
  writeLogsEnabled: false,
  pdpOfferEnabled: true,
  offerModalEnabled: true,
  cartOfferEnabled: true,
  sideCartOfferEnabled: true,
  cartBalancingEnabled: true,
  aftermarketModalEnabled: true,
  atcOfferEnabled: true,
  quickviewOfferEnabled: true,
  quickviewModalOfferEnabled: true,
  cartSPEnabled: false,
  SPEnabled: true,
});

// Helper: Check if a property path exists on an object
const checkPropertyExists = (obj) => (path) =>
  path.split('.').reduce(
    (acc, prop) => acc && acc[prop],
    obj
  ) !== undefined;

// Helper: Get missing properties from a list
const getMissingProperties = (propertiesToCheck, checkFn) =>
  propertiesToCheck.filter(prop => !checkFn(prop));

// Helper: Check currency mismatch
const hasCurrencyMismatch = (config) =>
  window.Shopify?.currency?.active !== config.currency;

// Helper: Build error message from errors array
const buildErrorMessage = (errors) =>
  "The following value(s) are null, undefined, or false:\n" +
  errors.map(error => `\t${error}`).join('\n');

// Main verification function
const verifyExtend = () => {
  const propertiesToCheck = [
    'window.Extend',
    'window.ExtendShopify',
    'window.Shopify',
    'window.Shopify.currency.active'
  ];
  
  const config = getConfiguration();
  const checkExists = checkPropertyExists(window);
  const missingProperties = getMissingProperties(propertiesToCheck, checkExists);
  
  const currencyError = hasCurrencyMismatch(config)
    ? ['window.Shopify.currency.active == config.currency']
    : [];
  
  const allErrors = [...missingProperties, ...currencyError];

  if (allErrors.length > 0) {
    throw createExtendError(buildErrorMessage(allErrors));
  }
};

export { extendError, verifyExtend, getConfiguration };